import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const ProjectCard = ({ project }) => {
  const [isHovered, setIsHovered] = useState(false);
  const hasDetails = project.description || (project.extra_images && project.extra_images.length > 0) || project.video_url;
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  // Helper function to get the correct image URL
  const getImageUrl = (imageUrl) => {
    // If URL starts with http:// or https://, it's already a complete URL (e.g., Cloudinary)
    if (imageUrl && (imageUrl.startsWith('http://') || imageUrl.startsWith('https://'))) {
      return imageUrl;
    }
    // Otherwise, it's a relative path, prepend BACKEND_URL
    return `${BACKEND_URL}${imageUrl}`;
  };

  const cardContent = (
    <div
      className="relative group cursor-pointer overflow-hidden bg-black"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      data-testid={`project-card-${project.id}`}
    >
      <div className="aspect-[251/333] relative">
        <img
          src={getImageUrl(project.main_image)}
          alt={project.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
        
        {/* Hover overlay */}
        <div
          className={`absolute inset-0 bg-gradient-to-t from-black via-black/80 to-transparent transition-opacity duration-300 ${
            isHovered ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
            <h3 className="text-xl font-bold mb-2 tracking-wide" data-testid={`project-title-${project.id}`}>{project.title}</h3>
            <p className="text-sm text-gray-300 mb-1" data-testid={`project-role-${project.id}`}>{project.role}</p>
            <p className="text-sm text-gray-400 mb-1" data-testid={`project-company-${project.id}`}>{project.company}</p>
            <p className="text-sm text-gray-500" data-testid={`project-year-${project.id}`}>{project.year}</p>
          </div>
        </div>
      </div>
    </div>
  );

  if (hasDetails) {
    return <Link to={`/projects/${project.id}`}>{cardContent}</Link>;
  }

  return cardContent;
};

export default ProjectCard;
